import { APP_BOOTSTRAP_LISTENER, Provider } from '@angular/core';
import { CoveoInitService, KeplerCoveoService } from '@services';

export const provideCoveoHeadless = (): Provider[] => [
    CoveoInitService,
    KeplerCoveoService,
    {
        provide: APP_BOOTSTRAP_LISTENER,
        useFactory: (initService: CoveoInitService, coveoService: KeplerCoveoService) => () => {
            // Load scripts after a short delay to ensure app is ready
            setTimeout(() => {
                coveoService.loadCoveoScripts().then(() => {
                    console.debug('[Injectors][CoveoHeadlessInjector] Successfully injected.');
                    initService.init();
                });
            }, 100);
        },
        deps: [CoveoInitService, KeplerCoveoService],
        multi: true,
    },
];
